import Emitter from "./Emitter";

export default class OpenGameHistory extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitGame({ wpgaction: "openGameHistory" });
    }
}
